import { useAuth } from "../hooks";
import { ReactElement, useEffect } from "react";
import { UserRole, userRoles } from "../../user/types/user.types";
import useNavigationApp from "../../../navigation/useNavigationApp";

/**
 * withAuth is a Higher Order Component that checks if the user is logged in.
 * If the user is not logged in, it redirects to the login page.
 * @param Component
 * @param props
 * @returns
 * */
export function withAuth(Component: React.FC<any>, props?: any) {
  return function () {
    const { isLogged } = useAuth();

    const navigationApp = useNavigationApp();

    useEffect(() => {
      if (!isLogged) {
        navigationApp.redirectToLoginPage()
      }
    }, [isLogged]); // eslint-disable-line

    return <Component {...props} />;
  };
}

export function WithAuth({ children , userRolesGranted}: { children: ReactElement, userRolesGranted?: UserRole[] }) {
  const { isLogged, userRole } = useAuth();


  const navigationApp = useNavigationApp();



  useEffect(() => {
    if (!isLogged) {
      navigationApp.redirectToLoginPage()
      return;
    }

    //TODO: go to organization page

    if (!userRoles) {
      navigationApp.redirectToLoginPage()
      return;
    }

    if (userRolesGranted && userRole && !userRolesGranted.includes(userRole)) {
      navigationApp.goToHome()
      return;
    }
  }, [isLogged]); // eslint-disable-line

  return <>{children}</>;
}
